import * as moment from 'moment';

import { RowDefinition, TicketViewModel } from '../../../models';
import { HeadingDefinition } from '../../../widgets/logbookTable/HeadingDefinition';


export function buildTable(tickets: TicketViewModel[]): { headings: HeadingDefinition[], body: RowDefinition[][] } {
    return { headings: getHeadings(), body: getBody(tickets) };
}

export function getHeadings(): HeadingDefinition[] {
    const headings: HeadingDefinition[] = [
        {
            label: 'ID',
            style: { width: '6em' }, 
            tooltip:'ID'
        },
        {
            classed: { 'fa-key': true },
            label: 'Category',
            style: { width: '10%' }, 
            tooltip:'Category'
        },
        {
            label: 'By',
            style: { width: '20%' }, 
            tooltip:'Creator'
        },
        {
            label: 'On',
            style: { width: '10em' }, 
            tooltip:'Creation date'
        },
        {
            label: 'Title',
            style: { width: '35%' }, 
            tooltip:'Ticket title'
        },
        {
            label: 'Description',
            style: { width: '35%' }, 
            tooltip:'Ticket description'
        },
        {
            classed: { 'fa-hourglass-end': true },
            label: '# of days to complete',
            style: { width: '3em' },
            tooltip: '# of days to complete'
        }
    ];
    return headings;
}

export function getBody(tickets: TicketViewModel[]): RowDefinition[][] {
    const body = tickets.map(t => {
        let daysToCompletion;
        const date = t.model.completedDate ?? t.model.closedDate;
        if (date) {
            daysToCompletion = moment(date).diff(moment(t.model.creationDate), 'd');
        }
        return [
            { content: t.model.id, classed: { 'right-col': true } },
            { content: t.model.type?.name },
            { content: t.creationUser, isUserName: true },
            { content: moment(t.model.creationDate).format('YYYY-MM-DD') },
            { content: t.model.title },
            { content: t.model.description },
            { content: daysToCompletion }
        ];
    });
    return body;
}